import React, { useState, useEffect } from "react";

import { Select, MenuItem, ListSubheader } from "@material-ui/core";

import { Discount, DiscountHandoutType } from "../../models/Discount";
import { DiscountSelectProps } from "./types";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { thunkFetchDiscounts } from "../../store/discounts/actions";
import moment from "moment";
import { DiscountDescription } from "../../components/misc/DiscountDescription";
import { useI18n } from "../../hooks/useI18n";

interface State {
  loading: boolean;
  discounts: ReadonlyArray<Discount>;
}

export const DiscountSelect = ({ onChange }: DiscountSelectProps) => {
  const dispatch = useDispatch();
  const [state, setState] = useState<State>({
    loading: true,
    discounts: []
  });
  const { t } = useI18n();

  const discountSelector =
    useSelector<AppState, ReadonlyArray<Discount>>(
      s => s.discounts.discounts
    ) || [];

  useEffect(() => {
    let discounts = discountSelector;

    if (discountSelector.length) {
      discounts = discounts.filter(d => moment(d.end).isAfter(moment()));
    }

    setState({
      ...state,
      loading: false,
      discounts: discounts.filter(
        d => d.type === 1 && d.handoutType === DiscountHandoutType.Manually
      )
    });
  }, [discountSelector]);

  useEffect(() => {
    if (!discountSelector || !discountSelector.length) {
      dispatch(thunkFetchDiscounts());
    }
  }, []);

  return (
    <Select
      defaultValue={"default"}
      onChange={event => {
        if (!event.target.value) return;

        onChange(event.target.value as string);
      }}
      style={{ width: "300px" }}
    >
      <MenuItem value={"default"}>{t("common.formFields.pickCode")}</MenuItem>
      <ListSubheader>{t("common.formFields.discounts")}</ListSubheader>
      {state.discounts.map(discount => (
        <MenuItem key={discount.id} value={discount.id}>
          <DiscountDescription discount={discount} />
        </MenuItem>
      ))}
    </Select>
  );
};
